import {t} from 'i18next';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import QRCode from 'react-qr-code';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import ActionButton from '../../components/ActionButton';
import CustomLabel from '../../components/CustomLabel';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import InputTextEditorComponent from '../../components/inputs/InputTextEditorComponent';
import YesNoDialog from '../../components/YesNoDialog';
import FileUploadService from '../../services/FileUploadService';
import QRCodeService from '../../services/QRCodeService';
import SettingService from '../../services/SettingService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import {handleDownloadPdf} from '../../utils/PrintUtils';
import QRCodeCreateRequest from './QRCodeCreateRequest';
import QRCodeDetailsResponse from './QRCodeDetailsResponse';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InputLanguageDropdownComponent from '../../components/inputs/InputLanguageDropdownComponent';

class QRCodeContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new QRCodeService());
        this.fileUploadService = new FileUploadService();
        this.state = {
            viewMode: props.viewMode,
            loading: true,
            elementId: props.elementId,
            locale: props.locale,
            supportedLocales: [],
            element: {
                translations: [],
            },
            difficultyLevels: [],
            parameters: [],
            showPublishDialog: false,
            showConfirmRemoveDialog: false,
        };
        this.settingService = new SettingService();
        this.fileUploadService = new FileUploadService();
        this.editorRef = React.createRef();
        this.renderlocaleuages = this.renderlocaleuages.bind(this);
        this.changelocaleuage = this.changelocaleuage.bind(this);
        this.reUpdateElement = this.beforeUpdateElement.bind(this);
        this.handlePublish = this.handlePublish.bind(this);
        this.viewMode = this.viewMode.bind(this);
        this.publish = this.publish.bind(this);
        this.componentRef = React.createRef();
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    updateElement(data) {
        console.log('supported languades', this.state.supportedLocales);

        this.setState(
            {
                element: QRCodeDetailsResponse.copy(this.state.element, data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
        if (data.status === 'ACTIVE' || data.status === 'REMOVED') {
            this.setState({
                viewMode: 'VIEW',
            });
        }
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId, locale} = this.state;
        this.beforeUpdateElement(viewMode, elementId, locale);
    }

    beforeUpdateElement(viewMode, elementId, locale) {
        console.log('---', viewMode, elementId, locale);
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId, locale)
                .then((data) => {
                    this.setState({loading: false, locale}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }

    initBeforeSetElement() {
        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState({
                    supportedLocales,
                    element:
                        this.props.viewMode === 'NEW'
                            ? new QRCodeCreateRequest(this.props.locale, supportedLocales)
                            : new QRCodeDetailsResponse(supportedLocales),
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });
    }

    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [
            {
                customRenderFunction: this.renderlocaleuages,
                rendered: true,
                className: 'float-left',
            },
            {
                label: t('global.back'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray float-right',
                rendered: true,
            },
        ];
    }

    prepareFooterItems() {
        const {detailUrl, editUrl, locale} = this.props;
        console.log(this.props, 'asd');
        const viewMode = this.viewMode() ? this.viewMode() : this.props.viewMode;
        const editHref = `${editUrl}/${this.state.element?.id}/${locale}`;
        const detailHref = `${detailUrl}/${this.state.element?.id}/${locale}`;
        return [
            {
                label: t('global.save'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                // href: AppPrefixUtils.locationHrefUrl(detailHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(detailHref));
                },
                className: 'gray',
                rendered: viewMode === 'EDIT',
            },
            {
                label: t('qrcode.edit'),
                // href: AppPrefixUtils.locationHrefUrl(editHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editHref));
                },
                iconName: 'mdi-pencil',
                className: 'float-right',
                rendered: this.props.viewMode === 'VIEW' && this.state.element.status === 'DRAFT',
            },
            {
                label: t('qrcode.publish'),
                onClick: this.handlePublish,
                className: 'float-right',
                iconName: 'mdi-publish',
                rendered: this.state.element.status === 'DRAFT' && viewMode === 'VIEW',
            },
            {
                label: t('qrcode.remove'),
                onClick: this.handleRemove.bind(this),
                className: 'float-right',
                iconName: 'mdi-delete',
                rendered: this.props.viewMode === 'VIEW' || this.props.viewMode === 'EDIT',
            },
        ];
    }

    goBackUrl() {
        const {backUrl} = this.props;
        return backUrl;
    }

    handleEditMode() {
        this.setState({
            viewMode: 'EDIT',
        });
    }

    handleRemove() {
        this.setState({
            showConfirmRemoveDialog: true,
        });
    }

    remove(type, costam, target) {
        if (target.value) {
            this.scrollToTop();
            this.service
                .removeQRCode(this.state.elementId)
                .then(() => {
                    const {backUrl} = this.props;
                    this.blockUi();
                    this.persistMessage('success', '', t('qrcode.successRemove'));
                    // window.location.href = backUrl;
                    this.props.history.push(backUrl);
                })
                .catch(() => {
                    this.setState({showConfirmRemoveDialog: false});
                    this.showErrorMessage(t('qrcode.removeError'));
                    this.unblockUi();
                });
        } else {
            this.setState({showConfirmRemoveDialog: false});
        }
    }

    handlePublish() {
        console.log('publish');
        this.setState({
            showPublishDialog: true,
        });
    }

    publish(type, costam, target) {
        if (target.value) {
            this.scrollToTop();

            this.blockUi();
            if (this._isMounted) {
                this.service
                    .publish(this.state.elementId)
                    .then(() => {
                        const {backUrl} = this.props;
                        this.blockUi();
                        this.persistMessage('success', '', t('qrcode.publishSuccess'));
                        // window.location.href = backUrl;
                        this.props.history.push(backUrl);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                        this.setState({showPublishDialog: false});
                        this.unblockUi();
                    });
            }
        } else {
            this.setState({showPublishDialog: false});
        }
    }

    viewMode() {
        const {viewMode} = this.props;
        return viewMode === 'NEW' ? viewMode : this.state?.element?.status === 'DRAFT' && viewMode === 'EDIT' ? 'EDIT' : 'VIEW';
    }

    getAddSucces() {
        return t('qrcode.createSuccess');
    }

    getUpdateSucces() {
        return t('qrcode.updateSuccess');
    }

    prepareElementBeforeRequest(element) {
        return element;
    }

    createOrUpdate() {
        const {element} = this.state;
        const {elementId, locale} = this.state;
        const request = this.prepareElementBeforeRequest(element);
        console.log(element);
        element.translations = Object.assign({}, element.translations);
        console.log(JSON.stringify(element));
        this.scrollToTop();
        if (this._isMounted) {
            if (!elementId) {
                this.service
                    .add(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            } else {
                this.service
                    .update(request, locale, elementId)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            }
        }
    }

    changelocaleuage(a, b, c) {
        const {editUrl} = this.props;
        const {elementId} = this.state;
        const locale = c.value;
        // window.location.href = AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale));

        this.beforeUpdateElement('VIEW', elementId, locale);
    }

    renderlocaleuages() {
        return (
            <InputLanguageDropdownComponent
                id='locale'
                name='locale'
                label={t('global.languageChooser')}
                validator={this.validator}
                validators='not_required'
                value={this.state.locale}
                options={this.state.supportedLocales}
                insideTable
                viewMode={'EDIT'}
                onChange={this.handleChange}
                rendered
                showClear={false}
                stateField={``}
            />
        );
    }

    getBackLabel() {
        return t('global.backToList');
    }

    render() {
        return (
            <div className='container-fluid'>
                <YesNoDialog
                    onChange={this.publish}
                    visible={this.state.showPublishDialog}
                    header={t('qrcode.publishHeader')}
                    name='visible'
                    onHide={() => {
                        this.setState({showPublishDialog: false});
                    }}
                >
                    <span>{t('qrcode.publishBody')}</span>
                </YesNoDialog>
                <YesNoDialog
                    onChange={this.remove.bind(this)}
                    visible={this.state.showConfirmRemoveDialog}
                    header={t('qrcode.removeTitle')}
                    name='visible'
                    onHide={() => {
                        this.setState({showConfirmRemoveDialog: false});
                    }}
                >
                    <span>{t('qrcode.removeBody')}</span>
                </YesNoDialog>
                {this.renderView()}
            </div>
        );
    }
    getContainerListName() {
        return 'qrcode-list-container';
    }

    breadCrumbItems() {
        return [
            {name: t('qrcode.listName'), url: '/qrcode-list'},
            {name: t('qrcode.details'), url: ``},
        ];
    }

    renderDetails() {
        const {elementId} = this.state;
        const {locale} = this.state;
        return (
            <React.Fragment>
                <div className='row'>
                    <div className='col-md-12 col-sm-12'>
                        <InputTextComponent
                            id={`${locale}-title`}
                            name='title'
                            label={t('qrcode.title')}
                            colClass='col-md-12'
                            value={this.state.element?.translations[locale]?.title}
                            validator={this.validator}
                            validators='required|max:128'
                            onChange={this.handleChange}
                            viewMode={this.viewMode()}
                            stateField={`element.translations[${locale}]`}
                        />
                        <InputNumberComponent
                            id='coinsToEarn'
                            name='coinsToEarn'
                            label={t('qrcode.coinsToEarn')}
                            colClass='col-md-12'
                            min={0}
                            value={this.state.element.coinsToEarn}
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            viewMode={this.viewMode()}
                        />
                        <InputNumberComponent
                            id='scanCount'
                            name='scanCount'
                            label={t('qrcode.scanCount')}
                            colClass='col-md-12'
                            min={0}
                            value={this.state.element.scanCount}
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            viewMode={this.viewMode()}
                        />
                        <InputCalendarRangeComponent
                            key={'active'}
                            idFrom={'activeFrom'}
                            idTo={'activeTo'}
                            nameTo={'activeTo'}
                            nameFrom={'activeFrom'}
                            label={t('')}
                            labelFrom={t('qrcode.activityRangeFrom')}
                            labelTo={t('qrcode.activityRangeTo')}
                            colClass='col-12'
                            from={this.state.element.activeFrom}
                            to={this.state.element.activeTo}
                            validator={[this.validator, this.validatorDraft]}
                            onChange={this.handleChange}
                            viewMode={this.viewMode()}
                            showTime
                            showIcon
                            validatorsTo={`required|date|after_or_equal_datetime~${moment(
                                this.state.element.activeFrom ? this.state.element.activeFrom : new Date()
                            )
                                .format('DD-MM-YYYY HH:mm')
                                .toString()}`}
                            placeholderFrom='dd-mm-rrrr GG:MM'
                            placeholderTo='dd-mm-rrrr GG:MM'
                            validateViewMode
                            dateFormatMoment='DD-MM-YYYY HH:mm'
                            validatorsToType='after_or_equal_datetime'
                        />
                    </div>
                    <InputTextEditorComponent
                        colClass='col-xl-12'
                        id='description'
                        key={`description-${this.props.viewMode}`}
                        name='description'
                        value={this.state.element?.translations[locale]?.description}
                        label={t('qrcode.description')}
                        validator={this.validator}
                        validators='required'
                        rows='5'
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        autoResize
                        editorRef={this.editorRef}
                        externalPhotos={true}
                        photos={this.state.element.photos}
                        photoUrl={`${this.service.getPath()}/photo/${elementId}`}
                        photoUploadUrl={`${this.fileUploadService.getPath()}/`}
                        photoLabel='fileName'
                        photoName='uuid'
                        handleError={this.onUploladError}
                        restrictExt={false}
                        token={this.authService.getToken()}
                        photoVarName='photos'
                        stateField={`element.translations[${this.state.locale}]`}
                        disabled={this.props.viewMode === 'VIEW'}
                    />
                    {this.state.viewMode === 'VIEW' || this.state.viewMode === 'EDIT' ? (
                        <div className='form-group'>
                            <div className='col-md-6 col-sm-6 float-left'>
                                <CustomLabel
                                    //colClass='col-md-12'
                                    className='p-label'
                                    label={t('qrcode.generatedqrcode') + ' ' + this.state.element.numericCode}
                                    rendered={true}
                                />
                                <QRCode
                                    ref={this.componentRef}
                                    size={256}
                                    style={{height: '300', maxWidth: '100%', width: '100%'}}
                                    value={this.state.element?.numericCode}
                                    viewBox={`0 0 256 256`}
                                />
                                {this.componentRef && this.componentRef.current && (
                                    <div className='col-md-12 download-qrcode-button'>
                                        {' '}
                                        <ActionButton
                                            id={'download-code-button'}
                                            label={`${t('qrcode.downloadButton')}`}
                                            key={`download-code-button`}
                                            className='p-link'
                                            variant='accent'
                                            handleClick={(e) => {
                                                e.preventDefault();
                                                handleDownloadPdf(
                                                    {
                                                        title: this.state.element?.translations[locale]?.title,
                                                        fileName: `Kod QR.pdf`,
                                                        refToPrint: this.componentRef.current,
                                                        activeFrom: `${moment(this.state.element.activeFrom).format('DD-MM-YYYY HH:mm')}`,
                                                        activeTo: `${moment(this.state.element.activeTo).format('DD-MM-YYYY HH:mm')}`,
                                                        activeFromLabel: t('qrcode.activeFrom'),
                                                        activeToLabel: t('qrcode.activeTo'),
                                                        descriptionLabel: t('qrcode.description'),
                                                        description: this.state.element?.translations[locale]?.description,
                                                    },
                                                    {
                                                        onBefore: () => this.blockUi(),
                                                        handleError: () => {
                                                            this.unblockUi();
                                                            this.showErrorMessage(t('global.errorMessage'));
                                                        },
                                                        onFinish: () => this.unblockUi(),
                                                    }
                                                );
                                            }}
                                            downloadFile
                                            iconName='mdi-download'
                                            iconSide='left'
                                            iconColor='white'
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : null}
                </div>
            </React.Fragment>
        );
    }
    onSelect = (e) => {
        this.setState(
            {
                selectedFile: e.files[0],
            },
            () => {
                this.uploadHandler();
            }
        );
    };

    onClear = () => {
        this.setState({
            selectedFile: undefined,
        });
    };
}

QRCodeContainer.defaultProps = {
    backUrl: '/qrcode-list',
    editUrl: '/qrcode/edit',
    detailUrl: '/qrcode/details',
    lazy: true,
};

QRCodeContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
};

export default withRouter(withTranslation()(QRCodeContainer));
